export default "__VITE_ASSET__D9SvM6AF__"